import { BibCategory } from './aud-bib-category.model';
import { GeoDsMeta } from './meta-data.model';
export class Library extends GeoDsMeta{
  Designation: string;
  Kind: string;
  Categories: BibCategory[];
  constructor(data?) {
    super();
    if (data) {
      Object.assign(this, data);
      if (data?.Categories) {
        this.Categories = [];
        data.Categories.forEach((category) => {
          this.Categories.push(new BibCategory(category));
        });
      }
    }
  }
}